<template>
  <div class="listing">
    <div class="columns columns-4">
      <ProductLoader v-for="index in 8" :key="index" v-if="loading"/>
      <ProductCard v-for="product in products" :id="product.id" :data="product" v-if="!loading"/>
    </div>
    <div class="no-products" v-if="!loading && !products.length">
      <div class="inner">
        <p>Nous ne trouvons aucun téléphone correspondant à vos critères</p>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from './ProductCard'
import ProductLoader from './ProductLoader'

import { mapState } from 'vuex'

export default {
  name: 'Listing',
  computed: {
    ...mapState({
      loading: state => state.products.loading,
      products: state => state.products.items
    })
  },
  components: {
    ProductCard,
    ProductLoader
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.listing{
  padding: 30px;
  margin: 0;

  @include responsive(mobile) {
    padding: 20px;
  }

  .columns{
    display: grid;
    grid-gap: 30px;

    @include responsive(mobile) {
      grid-gap: 20px;
    }

    &.columns-2 {
      grid-template-columns: 1fr 1fr;

      @include responsive(mobile) {
        grid-template-columns: 1fr;
      }
    }

    &.columns-3 {
      grid-template-columns: 1fr 1fr 1fr;

      @include responsive(smallScreen) {
        grid-template-columns: 1fr 1fr;
      }

      @include responsive(mobile) {
        grid-template-columns: 1fr;
      }
    }

    &.columns-4 {
      grid-template-columns: 1fr 1fr 1fr 1fr;

      @include responsive(smallScreen) {
        grid-template-columns: 1fr 1fr 1fr;
      }

      @include responsive(tablet) {
        grid-template-columns: 1fr 1fr;
      }

      @include responsive(mobile) {
        grid-template-columns: 1fr;
      }
    }

    &.columns-5 {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

      @include responsive(smallScreen) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }

      @include responsive(tablet) {
        grid-template-columns: 1fr 1fr;
      }

      @include responsive(mobile) {
        grid-template-columns: 1fr;
      }
    }
  }

  .no-products{
    .inner{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px;
      min-height: 300px;
      background-color: darken(#f9f9f9, 3%);
      @include radius(10px);
    }
  }
}
</style>
